import { Country } from '@/domain/countries'
import { Country as ReturnsApiCountry } from '@itsrever/returns-api-types'

export function toCountries(countries: ReturnsApiCountry[]): Country[] {
  return countries.map((country) => ({
    iso: country.iso ?? '',
    name: country.nicename ?? ''
  }))
}
